import {ExclamationCircleIcon} from "@heroicons/react/24/outline";
import {useTranslation} from "react-i18next";
import {getErrorMessageHtml, getInputErrorClasses, hasFieldAnError} from "../../Utils/FormHelpers";

export const TextInput = (props) => {
    const {
        register = null,
        name,
        translationIndex = null,
        errors,
        placeholder = '',
        type = 'text',
        onChange,
        value
    } = props;
    const {t} = useTranslation();

    return (
        <div className={'my-2'}>
            {
                translationIndex !== null && (
                    <label htmlFor={name}
                           className="block text-left text-sm font-medium leading-6 text-gray-900">
                        {t(`${translationIndex}`)}
                    </label>
                )
            }
            <div className="relative rounded-md shadow-sm">
                {
                    register !== null && (
                        <input
                            {...register(name)}
                            id={name}
                            placeholder={placeholder}
                            name={name}
                            type={type}
                            autoComplete={name}
                            className={`block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:outline-none focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6 ${getInputErrorClasses(errors, name)}`}
                        />
                    )
                }

                {
                    register === null && (
                        <input
                            name={name}
                            type={type}
                            value={value}
                            onChange={onChange}
                            placeholder={placeholder}
                            autoComplete={name}
                            className={`block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:outline-none focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6 ${getInputErrorClasses(errors, name)}`}
                        />
                    )
                }

                {
                    hasFieldAnError(errors, name) && (
                        <div
                            className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                            <ExclamationCircleIcon
                                className="h-5 w-5 text-red-500"
                                aria-hidden="true"/>
                        </div>
                    )
                }
            </div>

            {getErrorMessageHtml(errors, name)}
        </div>
    )
}